import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './config/store';
import Routes from "./screens/App";

import WebManager from './components/webManager/WebManager';

const rootElement = document.getElementById("root");

const Root = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <WebManager >
          <Routes />
        </WebManager>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

ReactDOM.render(<Root />,rootElement);